import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initSentry } from './lib/sentry';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import './index.css';
import { initEmbed, extractTokenFromUrl, isEmbedded } from './lib/embed';
import { getAccessToken, setAuth } from './lib/auth';

// Initialize Sentry before rendering
initSentry();

// Handle token from URL query param (?token=XXX) for iframe/WebView embedding
const urlToken = extractTokenFromUrl();
if (urlToken && !getAccessToken()) {
  // Store token — user info will be fetched on first protected route load
  setAuth(urlToken, '', { id: '', email: '', fullName: '', organizationId: '', projectIds: [] });
  // Remove token from URL to avoid leaking it in history/bookmarks
  const url = new URL(window.location.href);
  url.searchParams.delete('token');
  window.history.replaceState({}, '', url.toString());
}

// Initialize iframe/WebView communication bridge
if (isEmbedded()) {
  initEmbed();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error occurred. Please refresh the page.</p>}>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
